/**
 * PassSvg component.
 *
 * This component renders an SVG icon representing a pass. It is designed to be used in
 * various parts of the application where a visual representation of a pass is needed. The
 * SVG is styled using CSS variables, allowing for easy customization of its color and appearance.
 *
 * The component is defined as a functional component and uses the `displayName` property for
 * better debugging and readability in React DevTools. It is exported as the default export,
 * making it easy to import and use in other parts of the application.
 */
export const PassSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    aria-label="Pass visualization"
    fill="none"
    height="20"
    role="img"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4276_70884)">
      <path
        d="M18.3332 9.2333V9.99997C18.3321 11.797 17.7503 13.5455 16.6743 14.9848C15.5983 16.4241 14.0859 17.477 12.3626 17.9866C10.6394 18.4961 8.79755 18.4349 7.1119 17.8121C5.42624 17.1894 3.98705 16.0384 3.00897 14.5309C2.03089 13.0233 1.56633 11.24 1.68457 9.4469C1.80281 7.65377 2.49751 5.94691 3.66507 4.58086C4.83263 3.21482 6.41049 2.26279 8.16333 1.86676C9.91617 1.47073 11.7501 1.65192 13.3915 2.3833"
        stroke="var(--color-accent-green-500)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 3.33398L10 11.6757L7.5 9.17565"
        stroke="var(--color-accent-green-500)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4276_70884">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

PassSvg.displayName = 'PassSvg';

export default PassSvg;
